import { useEffect, useState } from "react";
import { RecipeHistoryItem, useGetRecipeHistory } from "../../../../api/recipeSimulator";

const PAGE_SIZE = 10;

export const useChangeHistoryData = (recipeId?: string, enabled: boolean = true) => {
  const [pageNumber, setPageNumber] = useState(1);
  const [historyItems, setHistoryItems] = useState<RecipeHistoryItem[]>([]);
  const [totalPages, setTotalPages] = useState(0);

  const { data: historyResponse, isLoading, isError } = useGetRecipeHistory(
    enabled ? recipeId : undefined,
    pageNumber,
    PAGE_SIZE
  );

  useEffect(() => {
    if (historyResponse) {
      if (Array.isArray(historyResponse.result)) {
        setHistoryItems(historyResponse.result);
        const pages = Math.ceil(historyResponse.total / PAGE_SIZE);
        setTotalPages(pages);
      } else {
        setHistoryItems([]);
        setTotalPages(0);
      }
    }
  }, [historyResponse]);

  return {
    pageNumber,
    setPageNumber,
    historyItems,
    totalPages,
    isLoading,
    isError,
  };
};
